import script from "./CreateBuilding.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateBuilding.vue?vue&type=script&lang=ts&setup=true"

import "./CreateBuilding.vue?vue&type=style&index=0&id=765f7a66&lang=css"

const __exports__ = script;

export default __exports__